import { use } from "react";
import FieldCitationButton from "../common/document-preview/FieldCitationButton";
import ObjectCardContext from "./ObjectCardContext";

interface Props {
  citationKey: string;
}

const ObjectFieldCitationButton = ({ citationKey }: Props) => {
  const objectCard = use(ObjectCardContext);

  if (!objectCard) {
    return null;
  }

  const isActive = objectCard.activeCitationKey === citationKey;

  return (
    <FieldCitationButton
      active={isActive}
      onClick={isActive ? undefined : () => objectCard.selectCitation(citationKey)}
    />
  );
};

export default ObjectFieldCitationButton;
